import React from "react";

function WhyChCAMan() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Why Choose Xeer for Crypto Asset Management?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  Managing crypto assets requires specialized expertise and
                  robust technology for security and operational efficiency.
                  Xeer Technology delivers custom-built solutions designed to
                  streamline asset management processes, ensuring transparency,
                  compliance, and enhanced asset security.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhyChCAMan;
